import {addComment} from '../../../../assets/javascripts/helpers/ajax.js';
import CustomValidityForm from '../custom-validity-form/custom-validity-form.js';

class CommentForm extends CustomValidityForm {
    constructor() {
        super();
        this.addEventListener('submit', this._onSubmit);
    }

    /**
     * @param {SubmitEvent & {
     *     target: HTMLFormElement;
     * }} event
     */
    async _onSubmit(event) {
        event.preventDefault();
        try {
            await addComment(new FormData(event.target));
            location.reload();
        } catch (error) {
            alert(error.message);
        }
    }
}

customElements.define('comment-form', CommentForm);
export default CommentForm;
